import script from "./ModalDeleteInstitutionalConfirmation.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalDeleteInstitutionalConfirmation.vue?vue&type=script&setup=true&lang=ts"

import "./ModalDeleteInstitutionalConfirmation.vue?vue&type=style&index=0&id=2fa47b20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fa47b20"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QBtn});
